import React, { useState, useEffect } from 'react'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import Row from 'react-bootstrap/Row'
import useMobileDetect from 'helpers/mobile-detect'
import TestimonialsList from '../testimonials-list/index'

import styles from './dolce-transformation.module.scss'

export default function Index (props) {
  const currentDevice = useMobileDetect()
  const [tab, setTab] = useState('featured')
  const [imageUrl, setImageUrl] = useState(
    '/static/images/testimonials/battleropes.png'
  )
  const bgImage = 'url(' + imageUrl + ') center center/ cover no-repeat #000000'

  useEffect(() => {
    if (currentDevice.isMobile() && currentDevice.width <= 768) {
      setImageUrl('/static/images/testimonials/battleropes-mobile.png')
    } else {
      setImageUrl('/static/images/testimonials/battleropes.png')
    }
  }, [currentDevice])

  return (
    <section id='dolce-transformation' className={styles['dolce-transform']}>
      <div className='wrapper' style={{ background: bgImage }}>
        <div className='container text-center'>
          <h2 className={styles['dolce-transform__title']}>DOLCE DIET TRANSFORMATIONS</h2>
          <Tab.Container
            id='controlled-tab-example'
            activeKey={tab}
            onSelect={(k) => setTab(k)}
            defaultActiveKey='featured'
          >
            <Row className='ms-auto me-auto'>
              <div className={styles['dolce-transform__tab-menu']}>
                <Nav as='ul' variant='pills'>
                  <Nav.Item as='li'>
                    <Nav.Link href='javascript:void(0)' eventKey='featured'>
                      featured <i className='arrow-down'></i>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as='li'>
                    <Nav.Link href='javascript:void(0)' eventKey='recent'>
                      recent <i className='arrow-down'></i>
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item as='li'>
                    <Nav.Link href='javascript:void(0)' eventKey='weightcutting'>
                      Weightcutting <i className='arrow-down'></i>
                    </Nav.Link>
                  </Nav.Item> */}
                </Nav>
              </div>
            </Row>

            <Tab.Content>
              <Tab.Pane eventKey='featured'>
                <TestimonialsList data={props.data.featured} />
              </Tab.Pane>
              <Tab.Pane eventKey='recent'>
                <TestimonialsList data={props.data.recent} />
              </Tab.Pane>
              {/* <Tab.Pane eventKey='weightcutting'>
                <TestimonialsList data={props.data.weightcutting} />
              </Tab.Pane> */}
            </Tab.Content>
          </Tab.Container>
        </div>
      </div>
    </section>
  )
}
